'use client';
import {useEffect, useState} from 'react';
import Image from 'next/image';

import {IoMdPlay} from 'react-icons/io';

interface VideoModalProps {
  isText?: boolean;
  videoUrl: string | null;
}

export default function VideoModal({
  isText = false,
  videoUrl,
}: VideoModalProps) {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (openModal) {
      document.documentElement.classList.add('overflow-y-hidden');
    } else {
      document.documentElement.classList.remove('overflow-y-hidden');
    }
  }, [openModal]);

  return (
    <>
      {openModal ? (
        <div
          role="dialog"
          className="fixed right-0 bottom-0 w-full h-full min-h-full bg-black z-[100] overflow-y-auto p-4">
          <div className="h-full flex flex-col">
            <div className="m-auto h-[calc(100%-120px)] w-full lg:w-[90%]">
              <iframe
                className="h-full w-full"
                frameBorder="0"
                allowFullScreen
                src={`https://www.youtube.com/embed/${videoUrl}`}
              />
            </div>
          </div>
          <button
            onClick={() => setOpenModal(false)}
            className="absolute top-4 right-4 z-50 cursor-pointer appearance-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-10 h-10 fill-current text-white"
              viewBox="0 -960 960 960">
              <path d="m256-168-88-88 224-224-224-224 88-88 224 224 224-224 88 88-224 224 224 224-88 88-224-224-224 224Z" />
            </svg>
          </button>
        </div>
      ) : isText ? (
        <button
          onClick={() => setOpenModal(true)}
          className="uppercase cursor-pointer">
          <span className="flex items-center">
            <IoMdPlay className="mr-1 text-primary h-6 w-6" />
            Play Video
          </span>
        </button>
      ) : (
        <div className="absolute w-full h-full bg-[rgba(0,0,0,.2)]">
          <Image
            width={80}
            height={80}
            src="https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/play.png"
            alt="open-video"
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[2] cursor-pointer"
            onClick={() => setOpenModal(true)}
          />
        </div>
      )}
    </>
  );
}
